import React from 'react';

import { OldTextField, OldTextFieldProps } from 'embeds/components/OldTextField';

interface Props extends OldTextFieldProps {
  hideErrorMessage?: boolean;
  input: any;
  meta: any;
}

const FormTextField: React.FC<Props> = ({
  helperText,
  hideErrorMessage,
  input,
  meta: { error, touched },
  type,
  ...other
}) => {
  // I'm keeping this for while, but I'm not sure if we still need this code.
  const handleChange = (inputValue: any) => {
    let newValue: any = inputValue;

    if (type === 'number') {
      newValue = newValue !== '' ? parseInt(newValue, 10) : '';
    }

    input.onChange(newValue);
  };

  return (
    <OldTextField
      error={touched && Boolean(error)}
      helperText={touched && Boolean(error) && !hideErrorMessage ? error : helperText}
      onChange={(event: any) => handleChange(event.target.value)}
      type={type}
      {...other}
      {...input}
      // https://github.com/react-dnd/react-dnd/issues/701
      onDrop={(e) => e.preventDefault()}
    />
  );
};

export default FormTextField;
